import { datadogRum } from '@datadog/browser-rum'
import packageJson from '../../../../package.json'
import { mixpanelService } from '../mixpanel/initializeMixPanel'
import { setSessionRecordingState } from './sessionRecording'

export function getGA4SessionId() {
  const cookieName = '_ga_JJRMGSE4DH'
  const cookieValue = document.cookie
    .split('; ')
    .find((row) => row.startsWith(cookieName))
    ?.split('=')[1]

  if (!cookieValue) return null

  const parts = cookieValue.split('.')
  const sessionNumber = parts[2]

  return sessionNumber
}

function shouldRecordSession(): boolean {
  // this is us manually creating the 20% recording of users in production
  return process.env.NEXT_PUBLIC_DATADOG_ENV === 'production'
    ? Math.random() < 0.2
    : false
}

function handleDatadogReady(shouldRecord: boolean): void {
  // Update our recording state based on our sampling decision
  setSessionRecordingState(shouldRecord)

  // Only start recording if this session was selected
  if (shouldRecord) {
    datadogRum.startSessionReplayRecording()
  }

  const internalContext = datadogRum.getInternalContext()
  const sessionId = internalContext?.session_id
  if (sessionId) {
    mixpanelService.registerSuperProperties({
      datadog_session_id: sessionId,
    })
  }
}

export default function initializeDatadog(): void {
  const shouldRecord = shouldRecordSession()

  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID || '',
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || '',
    site: 'us5.datadoghq.com',
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
    env: process.env.NEXT_PUBLIC_DATADOG_ENV,
    version: packageJson.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: shouldRecord ? 100 : 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  })

  datadogRum.onReady(() => handleDatadogReady(shouldRecord))
}
